import React, { useState, useEffect } from "react";
import { MapPin } from "lucide-react";
import LoadingCircle from "../../components/Common/LoadingCircle";
import LandingPageHeader from "../../components/LandingPage/LandingPageHeader";
import VenueCard from "../../components/Venue/VenueCard";
import NavigationButton from "../../components/Common/NavigationButton";
import { getDataByAll } from "../../api/venueApi";

const Venue = ({ bgColor = "bg-white" }) => {
  const [datas, setDatas] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    getDataByAll().then((res) => {
      if (isMounted && res) {
        // Ambil maksimal 4 data saja
        const limitedData = res.slice(0, 4);
        setDatas(limitedData);
        setLoading(false);
      }
    });
    return () => { isMounted = false; };
  }, []);

  if (loading) {
    return (
      <section id="partner" className="py-20 flex flex-col items-center justify-center min-h-[400px]">
        <LoadingCircle size="lg" />
        <p className="mt-4 text-slate-400 font-mono text-[10px] uppercase tracking-widest animate-pulse">
          Retrieving Data...
        </p>
      </section>
    );
  }

  return (
    <section id="venue" className={`py-6 md:py-10 scroll-mt-24 lg:scroll-mt-44 transition-colors duration-500 ${bgColor}`}>
      <div className="max-w-7xl mx-auto px-4">      
       {/* Header Section */}
        <LandingPageHeader 
          icon={MapPin} 
          title="Event Venues" 
          subtitle="Venues & Locations" 
          center={false} 
        />

        {/* Card Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {datas.map((items, index) => (
            <VenueCard key={items.id} venue={items} index={index} />
          ))}
        </div>
        
        {/* Navigation Section */}
        <NavigationButton 
              text="View Full List" 
              to="/venues" 
              color="#0F172A" 
              variant="solid" 
              className="mt-10 md:mt-12"
            />
      </div>
    </section>
  );
};

export default Venue;